import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonMode } from '@components/atoms/Button';
import { AddressOption } from '@components/molecules/AddressOption';
import { IconAccordion } from '@components/molecules/IconAccordion';
import { NewAddressForm } from '@components/molecules/NewAddressForm';
import { useData } from '@hooks/useData';
import { SelectableAddress } from '@types';
import { RadioButtonType } from '@components/atoms/RadioButton';

interface AtAddressProps {
    addresses: SelectableAddress[];
    selectedAddress: string | null;
    lastAddedAddress: SelectableAddress | null;
    handleOnChangeAddress: (id: string) => void;
    addressType: 'old' | 'new';
    setAddressType: (value: 'old' | 'new') => void;
}

const AtAddress: FC<AtAddressProps> = ({
    addresses,
    selectedAddress,
    lastAddedAddress,
    handleOnChangeAddress,
    addressType,
    setAddressType,
}) => {
    const { cart } = useData();
    const { t } = useTranslation();

    const translations = {
        addNewAddress: t('delivery-address-component.address.add-new-address'),
    };

    useEffect(() => {
        const initiallySelectedAddress = addresses.find((item) => item.uuid === cart?.data?.delivery?.shipToAddress?.uuid);
        if (initiallySelectedAddress) {
            handleOnChangeAddress(initiallySelectedAddress.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart?.data?.delivery?.shipToAddress]);

    return (
        <>
            <IconAccordion.IndentedContent>
                <div className="row pe-2 g-4">
                    {addresses.map((address, index) => (
                        <div key={`address-${index}`} className="col-12 col-xl-6">
                            <AddressOption
                                radioButton={{
                                    id: `existing-address-${index}`,
                                    name: 'existing-address',
                                    value: address.value,
                                    type: RadioButtonType.normal,
                                    checked: address.value === selectedAddress || lastAddedAddress?.value === address.value,
                                    onChange: handleOnChangeAddress,
                                }}
                                name={address.name}
                                lastName={address.lastName}
                                fiscalNumber={address.fiscalNumber}
                                address={address.address}
                                postalCode={address.postalCode}
                                region={address.region}
                            />
                        </div>
                    ))}
                </div>
            </IconAccordion.IndentedContent>
            <hr className="my-0" />
            <IconAccordion.IndentedContent>
                <Button mode={ButtonMode.link} label={translations.addNewAddress} onClick={() => setAddressType('new')} />
            </IconAccordion.IndentedContent>
            {addressType === 'new' ? <NewAddressForm type={'delivery'} /> : ''}
        </>
    );
};

export default AtAddress;
